export const prependHttps = (value: string) => {
  if (!!value && !/^(http:\/\/|https:\/\/).*/i.test(value)) {
    return `https://${value.trim()}`;
  }
  return value;
};
